import { Link } from "react-router-dom"
import Logo from "@components/logo"
import { FcMenu } from "react-icons/fc";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "@redux/store";
import { PlanType } from "@interfaces/fc-payment/subscriptions";
import { getSubdomainCodeEmail } from "@functions/getSubDomainSalud";

interface IHeaderLogoProps
{
    hide: boolean,
    setHide: (value: boolean) => void
}

interface IContextLabel
{
    text: string,
    variant: string
}

const HeaderLogo = (props: IHeaderLogoProps) => {
    const { t } = useTranslation("subscription")
    const session = useSelector((state: RootState) => state.session)
    const organization = useSelector((state: RootState) => state.organizations)

    /**
     * Label shown next to the logo: the current plan when the practitioner is in their
     * own practice (private practice or an organization they own), or the organization
     * name when they are working inside someone else's organization
     */
    const contextLabel = useMemo((): IContextLabel | null => {
        const isOwnPractice = !organization?.organizationType || organization?.predeterminedDrProx
        if (!isOwnPractice)
            return organization.organizationName ? { text: organization.organizationName, variant: "organization" } : null

        // Subscriptions only apply to DrProx core, other tenants are always premium
        if (getSubdomainCodeEmail(false) !== "DRPROX")
            return null

        // Same fallback as the account page: legacy, coupon and organization subscriptions only set isPremium
        const planType: PlanType = session.plan?.name ?? (session.isPremium ? "PREMIUM" : "FREE")
        const planName = t(`plans.${planType.toLowerCase()}.shortName`)
        const text = session.subscriptionType?.type === "CUP" ? `${planName} · ${t("freeTrial")}` : planName
        return { text, variant: planType.toLowerCase() }
    }, [organization, session.plan, session.isPremium, session.subscriptionType, t])

    return (
        <>
            { props.hide === true ? (
                <button
                    className="Menu__Icon"
                    onClick={() => props.setHide(false)}>
                    <FcMenu />
                </button>
                )
                :
                null
            }
            <Link to="/practitioner/calendar">
                <Logo />
            </Link>
            { contextLabel &&
                <span
                    className={`HeaderContextLabel HeaderContextLabel--${contextLabel.variant}`}
                    title={contextLabel.text}>
                    {contextLabel.text}
                </span>
            }
        </>
    )
}

export default HeaderLogo
